
import { useNavigate } from 'react-router-dom';
import useAxiosCall from './useAxiosCall';
import { useNotification } from '../Context/NotificationContext';
import { useSidebarPermission } from '../Context/SidebarPermissionContext';
const useLogout = () => {
  const navigate = useNavigate();
  const { makeApiCall } = useAxiosCall();
  const { notifications, setNotifications, notificationsFetch, setNotificationsFetch, notificationsCount, setNotificationsCount} = useNotification();
  const { setPermissions } = useSidebarPermission();

  const handleApiCallSuccess = () => {
    localStorage.removeItem('tokenKey');
    localStorage.removeItem('domain');
    localStorage.removeItem('acctDbKey');
    localStorage.removeItem('pusherTransportTLS');
    localStorage.removeItem('company');
    localStorage.removeItem('companyKey');
    localStorage.removeItem('refreshToken');
    navigate('/login');
  };

  const handleApiCallError = (errorMessage) => {
    console.log(errorMessage);
  };

  const handleLogout = async () => {
    setNotifications([]);
    setNotificationsCount(0);
    setPermissions([]);
    window.echo.leaveAllChannels();
    try {
      await makeApiCall({
        onSuccess: handleApiCallSuccess,
        onError: handleApiCallError,
        requestType: 'POST',
        url: 'logout',
      });

    } catch (error) {
      console.error('API call error:', error);
    }
  };

  return { handleLogout };
};

export default useLogout;
